<label>
  <input
    #input
    type="radio"
    [name]="name"
    [value]="value"
    [ngModel]="actualValue"
    (ngModelChange)="inputOnChange($event)"
    [attr.disabled]="disabled || null"
  />
  <ng-content></ng-content>
</label>
